import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './LoadingConfig.Styles';

const bodyWheelLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.bodyFirstSectionLineStyle),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.bodySecondSectionSquareStyle),
  },
];

const footerLoadingConfig = theme => [
  {
    left: setLoadingConfigObject('square', 1, null, styles.footerFirstSectionLeftLineStyle),
    right: setLoadingConfigObject('square', 1, null, styles.footerFirstSectionRightLineStyle),
    style: styles.footerFirstSectionStyle,
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.footerSecondSectionSquareStyle),
    main: [
      setLoadingConfigObject('line', 1, '97%', styles.footerSecondSectionMainFirstLineStyle),
      setLoadingConfigObject('line', 1, '31%', styles.footerSecondSectionMainSecondLineStyle),
    ],
    right: setLoadingConfigObject('square', 1, null, styles.footerSecondSectionRightLineStyle),

    style: styles.footerSecondSectionStyle(theme),
  },
  {
    main: setLoadingConfigObject('line', 1, '92%', styles.divider),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.footerThirdSectionSquareStyle),
  },
];
const footerButtonLoadingConfig = theme => [footerLoadingConfig(theme)[3]];
const setupAutoBillBodyLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.bodyTitleLineStyle),
  },
  {
    left: [
      'row',
      setLoadingConfigObject('circle', 1, null, styles.firstSectionCircleStyle),
      setLoadingConfigObject('circle', 1, null, styles.circleStyle),
      setLoadingConfigObject('circle', 1, null, styles.circleStyle),
      setLoadingConfigObject('circle', 1, null, styles.circleStyle),
      setLoadingConfigObject('circle', 1, null, styles.circleStyle),
      setLoadingConfigObject('circle', 1, null, styles.circleStyle),
      setLoadingConfigObject('circle', 1, null, styles.lastSectionCircleStyle),
    ],
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.descriptionFirstSectionSquareStyle),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.descriptionSecondSectionSquareStyle),
  },
];

const setupAutoBillFooterLoadingConfig = theme => [
  ...footerLoadingConfig(theme),
  {
    main: setLoadingConfigObject('square', 1, null, styles.footerThirdSectionSquareStyle),
  },
];

const customTabBodyloadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.footerFirstSectionLeftLineStyle),
    style: styles.titleStyle,
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.leftCustomTabStyle),
    right: setLoadingConfigObject('square', 1, null, styles.rightCustomTabStyle),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.bodySecondSectionRectangleStyle),
  },
];

export {
  bodyWheelLoadingConfig,
  footerLoadingConfig,
  shimmerPlaceholderConfig,
  setupAutoBillBodyLoadingConfig,
  setupAutoBillFooterLoadingConfig,
  customTabBodyloadingConfig,
  footerButtonLoadingConfig,
};
